import { colors } from 'styles/Common';

const appBase = {
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: colors.colors1Primary,
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            main: colors.fillBlue00Brand,
        },
        error: {
            main: colors.colors6Error
        },
        warning: {
            main: colors.colors7Warning
        },
        info: {
            main: colors.colors2Secondary
        },
        success: {
            main: colors.colors5Success
        },
        background: {
            default: colors.fillGray03
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2
    },
    typography: {
        fontFamily: ['"3MCircularTT"'].join(','),
        h1: {
            fontSize: '70px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            color: colors.black,
            lineHeight: 1.14,
            letterSpacing: '1px'
        },
        h2: {
            fontSize: '60px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            color: colors.black,
            lineHeight: 1,
            letterSpacing: '1px'
        },
        h3: {
            fontSize: '48px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            color: colors.fillGray94,
            lineHeight: 1.02,
            letterSpacing: 'normal'
        },
        h4: {
            fontSize: '34px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            color: colors.fillGray94,
            lineHeight: 1.15,
            letterSpacing: '0.07px',
            textAlign: 'center'
        },
        h5: {
            fontSize: '24px',
            fontWeight: '300',
            fontStretch: 'normal',
            fontStyle: 'normal',
            color: colors.fillGray94,
            lineHeight: 1.33,
            letterSpacing: 'normal'
        },
        h6: {
            fontSize: '16px',
            fontWeight: '300',
            fontStretch: 'normal',
            fontStyle: 'normal',
            color: colors.fillGray94,
            lineHeight: 'normal',
            letterSpacing: 'normal'
        },
        subtitle1: {
            fontSize: '16px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.75,
            letterSpacing: '0.09px',
            color: colors.fillGray70
        },
        /*User-InterfaceSubtitle2Text-SecondaryCentered*/
        subtitle2: {
            fontSize: '14px',
            fontWeight: 300,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.5,
            letterSpacing: '0.07px',
            color: colors.fillGray70,
            textAlign: 'center'
        },
        subtitle3: {
            fontSize: '22px',
            fontWeight: 300,
            fontStretch: 'normal',
            fontStyle: 'normal',
            color: colors.black,
            lineHeight: 'normal',
            letterSpacing: 'normal'
        },
        body2: {
            fontSize: '14px',
            fontWeight: 300,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.5,
            letterSpacing: '0.07px',
            color: colors.fillGray70
        },
        button: {
            textTransform: 'none'
        }
    },

};

export default appBase;